import { Scope } from './interface'
declare const window: any;
export default function a8I18N(scope: Scope) {
    var a8I18NTypeDefs = `
          ${(scope === 'inline' || scope === 'functionClient' || scope === "solo") ?
            ` declare var i18n: {
                setLang (lang: string): Promise<any>;
                getLang (): Promise<any>;
                loadLang (lang?: string): Promise<any>;
                getKey(key: string): Promise<any>;
               };
              `
            :
            ''
        }
      ${window.a8I18NTypeDefs}
      `
    return a8I18NTypeDefs;
}


